/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CallType = {
    IN: 'IN',
    OUT: 'OUT',
    CALLBACK: 'CALLBACK'
} as const;
export type CallType = typeof CallType[keyof typeof CallType];

